import { TRANSLATED_ACTIONS } from '@/common/messages/actions';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { SetPasswordBackendError } from './constants';

export const Page = defineMessages({
  title: {
    id: 'app.auth.setPassword.Page.title',
  },
  hint: {
    id: 'app.auth.setPassword.Page.hint',
  },
  setPasswordError: {
    id: 'app.auth.setPassword.Page.setPasswordError',
  },
  [SetPasswordBackendError.WeakPassword]: {
    id: 'app.auth.setPassword.Page.weakPassword',
  },
  [SetPasswordBackendError.PasswordRequired]: {
    id: 'app.auth.setPassword.Page.passwordRequired',
  },
  [SetPasswordBackendError.PasswordMatchPasswordCheck]: {
    id: 'app.auth.setPassword.Page.passwordMatchPasswordCheck',
  },
  [SetPasswordBackendError.TokenUsed]: {
    id: 'app.auth.setPassword.Page.tokenUsed',
  },
  [SetPasswordBackendError.ShortPassword]: {
    id: 'app.auth.setPassword.Page.shortPassword',
  },
  tokenExpired: {
    id: 'app.auth.setPassword.Page.tokenExpired',
  },
  tokenInvalid: {
    id: 'app.auth.setPassword.Page.tokenInvalid',
  },
  pass: {
    id: 'app.auth.setPassword.Page.pass',
  },
  passwordRequired: {
    id: 'app.auth.setPassword.Page.passwordRequired',
  },
  passwordCheckRequired: {
    id: 'app.auth.setPassword.Page.passwordCheckRequired',
  },
  passwordMatchPasswordCheck: {
    id: 'app.auth.setPassword.Page.passwordMatchPasswordCheck',
  },
  passCheck: {
    id: 'app.auth.setPassword.Page.passCheck',
  },
  send: TRANSLATED_ACTIONS.send,
  cancel: TRANSLATED_ACTIONS.cancel,
});
